import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AccountService } from '../account.service';
import { HostnameService } from '../hostname.service';
import { convertNhiemvuDataForEdit, convertNhomNhiemvuDataForEdit } from './nhom-nhiem-vu.service.utils';

@Injectable({ providedIn: 'root' })
export class NhomNhiemvuService {
    constructor(
        private httpClient: HttpClient,
        private accountService: AccountService,
        private hostnameService: HostnameService
    ) {}

    public static DEFAULT_TIEUBAN_ID = '6';

    async add(tieuban: any, formData: any) {
        return this.httpClient
            .post<any>(
                this.hostnameService.UbndtphcmAPI_Producerv1 + '/nhomnhiemvu?tieuban=' + tieuban,
                {
                    data: formData,
                },
                {
                    headers: { apikey: this.accountService.getAPIKey() },
                }
            )
            .toPromise();
    }

    async addEmptyGetId(tieuban: any) {
        return this.httpClient
            .post<any>(
                this.hostnameService.UbndtphcmAPI_Producerv1 + '/nhomnhiemvu/add-empty-get-id?tieuban=' + tieuban,
                {},
                {
                    headers: { apikey: this.accountService.getAPIKey() },
                }
            )
            .toPromise();
    }

    async edit(nhom_id: string, formData: any) {
        formData = convertNhomNhiemvuDataForEdit(formData);

        return this.httpClient
            .put<any>(
                this.hostnameService.UbndtphcmAPI_Producerv1 + '/nhomnhiemvu?id=' + nhom_id,
                {
                    data: formData,
                },
                {
                    headers: { apikey: this.accountService.getAPIKey() },
                }
            )
            .toPromise();
    }

    async delete(nhom_id: string) {
        return this.httpClient
            .delete<any>(this.hostnameService.UbndtphcmAPI_Producerv1 + '/nhomnhiemvu?id=' + nhom_id, {
                headers: { apikey: this.accountService.getAPIKey() },
            })
            .toPromise();
    }

    /**
     * Sửa một phần dữ liệu
     * @param nhom_id
     * @param type 'nhom-info' hoặc 'nhiemvu'
     * @param dataOfType
     * Dữ liệu kiểu {'ten_nhiem_vu': '...','ten_nhiem_vu_cu': '...','data': '...'}
     * hoặc {'title': '...','styles': '...'}
     * @param nhiemvu_action
     * @returns
     */
    async editPart(
        nhom_id: string,
        type: 'nhom-info' | 'nhiemvu',
        dataOfType: any,
        nhiemvu_action: 'update' | 'delete' | undefined = undefined
    ) {
        if (type == 'nhiemvu' && nhiemvu_action == 'update')
            dataOfType.data = convertNhiemvuDataForEdit(dataOfType.data);

        return this.httpClient
            .post<any>(
                this.hostnameService.UbndtphcmAPI_Producerv1 +
                    '/nhomnhiemvu/part/edit?id=' +
                    nhom_id +
                    '&type=' +
                    type +
                    (nhiemvu_action ? '&action=' + nhiemvu_action : ''),
                {
                    data: dataOfType,
                },
                {
                    headers: { apikey: this.accountService.getAPIKey() },
                }
            )
            .toPromise();
    }

    async getAll(tieuban: any) {
        return this.httpClient
            .get<any>(this.hostnameService.UbndtphcmAPI_Readv1 + '/nhomnhiemvu/' + tieuban, {
                headers: { apikey: this.accountService.getAPIKey() },
            })
            .toPromise();
    }

    async getFileBinary(file_id: string) {
        return this.httpClient
            .get<any>(this.hostnameService.UbndtphcmAPI_Readv1 + '/nhomnhiemvu/file-binary?id=' + file_id, {
                headers: { apikey: this.accountService.getAPIKey() },
            })
            .toPromise();
    }

    async getAllFileBinary(file_ids: string[]) {
        return this.httpClient
            .post<any>(
                this.hostnameService.UbndtphcmAPI_Readv1 + '/nhomnhiemvu/get-file-binary-by-ids',
                {
                    ids: file_ids,
                },
                {
                    headers: { apikey: this.accountService.getAPIKey() },
                }
            )
            .toPromise();
    }

    async downloadTemplate() {
        return this.httpClient
            .get<any>(this.hostnameService.UbndtphcmAPI_Readv1 + '/nhomnhiemvu/template', {
                headers: { apikey: this.accountService.getAPIKey() },
            })
            .toPromise();
    }

    async uploadFileTemplate(tieuban: any, file: File, inputType: string) {
        let formData = new FormData();
        formData.set('file', file);
        formData.set('type', inputType);
        return this.httpClient
            .post<any>(
                this.hostnameService.UbndtphcmAPI_Producerv1 + '/nhomnhiemvu/template?tieuban=' + tieuban,
                formData,
                {
                    headers: { apikey: this.accountService.getAPIKey() },
                }
            )
            .toPromise();
    }

    async extractAll(with_images: boolean, with_files: boolean, nhom_id: any = undefined, tieuban_id: any = undefined) {
        return this.httpClient
            .get<any>(
                this.hostnameService.UbndtphcmAPI_Readv1 +
                    '/nhomnhiemvu/extract-all?with-images=' +
                    (with_images ? 'true' : 'false') +
                    '&with-files=' +
                    (with_files ? 'true' : 'false') +
                    (nhom_id ? `&id=${nhom_id}` : '') +
                    (tieuban_id ? `&tieuban=${tieuban_id}` : ''),
                {
                    headers: { apikey: this.accountService.getAPIKey() },
                }
            )
            .toPromise();
    }

    async extractAllIds(nhomIds: any[], with_images: boolean, with_files: boolean) {
        return this.httpClient
            .post<any>(
                this.hostnameService.UbndtphcmAPI_Readv1 +
                    '/nhomnhiemvu/extract-all/ids?with-images=' +
                    (with_images ? 'true' : 'false') +
                    '&with-files=' +
                    (with_files ? 'true' : 'false'),
                { ids: nhomIds },
                {
                    headers: { apikey: this.accountService.getAPIKey() },
                }
            )
            .toPromise();
    }

    async extractAllDonVi(
        with_images: boolean,
        with_files: boolean,
        nhom_id: any = undefined,
        tieuban_id: any = undefined
    ) {
        return this.httpClient
            .get<any>(
                this.hostnameService.UbndtphcmAPI_Readv1 +
                    '/nhomnhiemvu/extract-all-by-department?with-images=' +
                    (with_images ? 'true' : 'false') +
                    '&with-files=' +
                    (with_files ? 'true' : 'false') +
                    (nhom_id ? `&id=${nhom_id}` : '') +
                    (tieuban_id ? `&tieuban=${tieuban_id}` : ''),
                {
                    headers: { apikey: this.accountService.getAPIKey() },
                }
            )
            .toPromise();
    }

    async extractAllDonViIds(nhomIds: any[], with_images: boolean, with_files: boolean) {
        return this.httpClient
            .post<any>(
                this.hostnameService.UbndtphcmAPI_Readv1 +
                    '/nhomnhiemvu/extract-all-by-department/ids?with-images=' +
                    (with_images ? 'true' : 'false') +
                    '&with-files=' +
                    (with_files ? 'true' : 'false'),
                { ids: nhomIds },
                {
                    headers: { apikey: this.accountService.getAPIKey() },
                }
            )
            .toPromise();
    }

    async getDashboard(tieuban: any) {
        return this.httpClient
            .get<any>(this.hostnameService.UbndtphcmAPI_Readv1 + '/nhomnhiemvu-dashboard?tieuban=' + tieuban, {
                headers: { apikey: this.accountService.getAPIKey() },
            })
            .toPromise();
    }

    async getDashboardNhiemVuStatusList(tieuban: any) {
        return this.httpClient
            .get<any>(
                this.hostnameService.UbndtphcmAPI_Readv1 +
                    '/nhomnhiemvu-dashboard/nhiemvu-status-list?tieuban=' +
                    tieuban,
                {
                    headers: { apikey: this.accountService.getAPIKey() },
                }
            )
            .toPromise();
    }

    async sendEmail(element: any) {
        return this.httpClient
            .post<any>(this.hostnameService.UbndtphcmAPI_Producerv1 + '/nhomnhiemvu-send-email', element, {
                headers: { apikey: this.accountService.getAPIKey() },
            })
            .toPromise();
    }

    async addMessage(
        nhom_id: any,
        index: number,
        element: any,
        is_send_email: boolean = false,
        email_info: any = undefined
    ) {
        return this.httpClient
            .post<any>(
                this.hostnameService.UbndtphcmAPI_Producerv1 +
                    '/nhomnhiemvu-send-email/message?nhom-id=' +
                    nhom_id +
                    '&index=' +
                    index +
                    '&is-send-email=' +
                    (is_send_email ? 'true' : 'false'),
                { element, email_info },
                {
                    headers: { apikey: this.accountService.getAPIKey() },
                }
            )
            .toPromise();
    }

    async getAllNVHistoryShort(id: string, index: string) {
        return this.httpClient
            .get<any>(
                this.hostnameService.UbndtphcmAPI_Readv1 +
                    '/nhomnhiemvu-nhiemvu/history-short?id=' +
                    id +
                    '&index=' +
                    index,
                {
                    headers: { apikey: this.accountService.getAPIKey() },
                }
            )
            .toPromise();
    }
}
